import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ShareddataService} from '@shared/services/shareddata.service';
import {CrudUserService} from '@shared/services/crud-user.service';
import {Location} from '@angular/common';
import {CrudMarketsService} from '@shared/services/crud-markets.service';
import {CrudMarketgroupsService} from '@shared/services/crud-marketgroups.service';

@Component({
  selector: 'app-users-tool-main',
  templateUrl: './users-tool-main.component.html',
  styleUrls: ['./users-tool-main.component.scss']
})
export class UsersToolMainComponent implements OnInit {

  userid: string;

  constructor(
    protected httpusercrud: CrudUserService,
    protected httpmarketcrud: CrudMarketsService,
    protected httpmarketgroupcrud: CrudMarketgroupsService,
    protected route: ActivatedRoute,
    public sharedData: ShareddataService,
    protected router: Router,
    private location: Location
  ) {
    this.userid = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    // tslint:disable-next-line:radix
    if (this.sharedData.getSelectedUser().id !== parseInt(this.userid)) {
      this.httpusercrud.getEntity(this.userid).subscribe( (data) => {
        this.sharedData.setSelectedUser(data.results);
      });
    }
    if (this.sharedData.getMarkets().length === 0) {
      // this.httpmarketcrud.getEntities().subscribe( data => {
      this.httpmarketcrud.getActiveMarkets().subscribe( data => {
        this.sharedData.setMarkets(data.results);
      });
    }
    if (this.sharedData.getMarketGroups().length === 0) {
      this.httpmarketgroupcrud.getEntities().subscribe( data => {
        this.sharedData.setMarketGroups(data.results);
      });
    }
  }

  goBack() {
    this.location.back();
  } // onCancel

  getUserId() {
    // tslint:disable-next-line:radix
    return parseInt(this.userid);
  }
}
